import { faArrowRight, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, RouteComponentProps, useHistory, useParams } from "react-router-dom";
import AuthContext from "../AuthContext";
import Alert from "../components/Alert";
import Button from "../components/Button";
import CenterContainer from "../components/CenterContainer";
import { QuestionAnswer, QuestionnaireFillIn } from "../components/QuestionAnswer";
import Spinner from "../components/Spinner";
import Title from "../components/Title";
import { Questionnaire } from "consumerhouse-shared";
import { Translation, useLanguage } from "../useLanguage";
import { List as LoadingList } from "react-content-loader";
import { ButtonContainer } from "../components/ButtonContainer";

export function FillQuestionnaireWithId(props: { questionnaireId: string; accessToken?: string; afterRedirect?: string }) {
    const [questionnaire, setQuestionnaire] = useState<Questionnaire | null>(null);
    const { client } = useContext(AuthContext);
    const language = useLanguage();
    const history = useHistory();
    const [applyError, setApplyError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            let q = await client.fetch("/questionnaire/questions", { id: props.questionnaireId }, "POST", props.accessToken);
            if (q.status === "ok") {
                setQuestionnaire(q.questionnaire);
            } else if (q.error === "test-not-registered") {
                history.push(
                    props.accessToken
                        ? `/apply/${q.testId}?accessToken=${encodeURIComponent(props.accessToken)}&redirect=${encodeURIComponent(
                              props.afterRedirect || ""
                          )}`
                        : `/apply/${q.testId}&redirect=${encodeURIComponent(props.afterRedirect || "")}`
                );
            } else {
                history.push("/");
            }
        })();
    }, [client, props.questionnaireId]);

    async function onDone(stopped: boolean) {
        setLoading(true);
        let res = await client.fetch("/questionnaire/answer/finish", { id: props.questionnaireId }, "POST", props.accessToken);
        if (res.status === "error") {
            setApplyError(res.error);
        } else {
            if (props.afterRedirect && props.afterRedirect.startsWith("/")) {
                history.push(props.afterRedirect);
            } else {
                history.push("/account");
            }
        }
        setLoading(false);
    }

    return (
        <CenterContainer style={{ margin: "2em 0" }}>
            {questionnaire ? (
                <div>
                    <Title>{questionnaire.name}</Title>
                    <QuestionnaireFillIn accessToken={props.accessToken} questions={questionnaire!.questions!} onDone={onDone} loading={loading} />

                    {applyError && (
                        <Alert icon={faTimesCircle}>
                            <p>{language(applyError as Translation)}</p>
                        </Alert>
                    )}
                </div>
            ) : (
                <LoadingList />
            )}
        </CenterContainer>
    );
}

export function FillQuestionnaire({ match }: RouteComponentProps<{ id: string }>) {
    const [accessToken, redirect] = useMemo(() => {
        let params = new URLSearchParams(window.location.search);
        return [params.get("accessToken") || undefined, params.get("redirect") || undefined];
    }, [window.location.search]);

    return <FillQuestionnaireWithId accessToken={accessToken} questionnaireId={match.params.id} afterRedirect={redirect} />;
}
